import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManageBot = () => {
  const [faqs, setFaqs] = useState([]);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editId, setEditId] = useState(null);

  const fetchFAQs = async () => {
    try {
      const res = await axios.get(window.API_URL + '/faq');
      setFaqs(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchFAQs();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const token = localStorage.getItem('portalToken') || localStorage.getItem('adminToken');
    
    const faqData = { question, answer };

    try {
      if (editId) {
        await axios.put(`${window.API_URL}/faq/${editId}`, faqData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(window.API_URL + '/faq', faqData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      fetchFAQs();
      resetForm();
    } catch (err) {
      console.error(err);
      alert(`Error ${editId ? 'updating' : 'adding'} FAQ`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setQuestion('');
    setAnswer('');
    setEditId(null);
  };

  const handleEdit = (faq) => {
    setEditId(faq._id);
    setQuestion(faq.question);
    setAnswer(faq.answer);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem('portalToken') || localStorage.getItem('adminToken');
    try {
      await axios.delete(`${window.API_URL}/faq/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchFAQs();
    } catch (err) {
      console.error(err);
      alert('Error deleting FAQ');
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8 text-gray-800">Train Support Bot</h1>
      <p className="text-gray-600 mb-6">Add questions and answers here. The chatbot will use these to automatically reply to customers. If a customer asks something similar to the "Question", the bot will reply with the "Answer".</p>
      
      {/* Add/Edit Form */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-[#f06600]">
            {editId ? 'Edit Knowledge Base Item' : 'Add New Knowledge Base Item'}
          </h2>
          {editId && (
            <button onClick={resetForm} className="text-sm text-gray-500 hover:text-gray-700 underline">
              Cancel Edit
            </button>
          )}
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input 
            type="text" 
            placeholder="Question or Keywords (e.g., What are your opening hours?)" 
            value={question} 
            onChange={e => setQuestion(e.target.value)} 
            required 
            className="border p-2 rounded" 
          />
          <textarea 
            placeholder="Bot Answer (e.g., We are open 24/7!)" 
            value={answer} 
            onChange={e => setAnswer(e.target.value)} 
            required 
            className="border p-2 rounded h-24"
          ></textarea>
          
          <button type="submit" disabled={isSubmitting} className={`text-white py-2 rounded-lg font-bold transition ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#f06600] hover:bg-[#d05800]'}`}>
            {isSubmitting ? (editId ? 'Updating...' : 'Adding...') : (editId ? 'Update Item' : 'Add Item')}
          </button>
        </form>
      </div>

      {/* FAQs List */}
      <div className="bg-white p-6 rounded-xl shadow-md">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Current Knowledge Base</h2>
        <div className="flex flex-col gap-4">
          {faqs.map(faq => (
            <div key={faq._id} className="border border-gray-200 rounded-lg p-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <div className="flex-1">
                <h3 className="font-bold text-lg text-gray-800">Q: {faq.question}</h3>
                <p className="text-gray-600 mt-1"><span className="font-semibold text-gray-700">A:</span> {faq.answer}</p>
              </div>
              <div className="flex gap-2 min-w-[150px]">
                <button onClick={() => handleEdit(faq)} className="flex-1 py-1 px-3 bg-blue-100 text-blue-600 font-semibold rounded hover:bg-blue-200 transition">Edit</button>
                <button onClick={() => handleDelete(faq._id)} className="flex-1 py-1 px-3 bg-red-100 text-red-600 font-semibold rounded hover:bg-red-200 transition">Delete</button>
              </div>
            </div>
          ))}
          {faqs.length === 0 && <p className="text-gray-500">No data found. Train the bot by adding questions above.</p>}
        </div>
      </div>
    </div>
  );
};

export default ManageBot;
